/* ================================================== */
/* Scripts ========================================== */
/* ================================================== */

const $ = require('jquery');
// const google_maps = require('./google-maps.js');

require('@popperjs/core');
require('bootstrap');
require('slick-carousel');
require('magnific-popup');

window.jQuery = $;

$(function () {
  container_fix();
  // google_maps.init_google_maps();
  magnific_init();
  mega_menu();
  slick_init();
  noticeBanner(0.075, '.notice-banner .slider-track');
  headerFix();
  
  /* Automatically updates path names for local development */
  if (window.location.hostname === 'touchstar' || window.location.hostname === 'localhost') {
    universal_path_change('touchstar', 'touchstar');
  }

  /* Applies the "active" class to hyperlinks within the header */
  $("header .nav [href]").each(function () {
    if (this.href == window.location.href) { $(this).addClass("active"); }
  }); 

  function headerFix() {
    let header = $("header");
    let headerHeight = $(header).outerHeight();
    var firstSection = $('body').find('section').first();
    $(firstSection).css("margin-top", `${headerHeight}px`);
  }

  /* Handles resize events */
  $(window).on("resize", function () { 
    container_fix(); 
    mega_menu(); 
    headerFix();
  });

  /* Handles scroll events */
  $(window).on("scroll", function () {
    check_scroll();
  });

  /* Enables smooth scrolling on hyperlinks tagged with "smooth" class */
  $('a.smooth[href*="#"]').on("click", function (event) {
    if (location.pathname.replace(/^\//, "") == this.pathname.replace(/^\//, "") && location.hostname == this.hostname) {
      var target = $(this.hash);
      var offset = $("header").outerHeight();
      target = target.length ? target : $("[name=" + this.hash.slice(1) + "]");
      if (target.length) { event.preventDefault(); $("html, body").animate({ scrollTop: target.offset().top - offset }, 1000); }
    }
  });

  // Mobile menu toggle
  $(".toggle").on("click", function () {
    var toggle = $(this);
    toggle.toggleClass("open");
    $(this).prev(".parent-item").toggleClass("open");
    var submenu = $(this).next(".submenu");
    submenu.addClass("open");
  });

  $(".back-btn").on("click", function() {
    var currentItem = $(this);
    var submenu = currentItem.closest(".submenu");
    submenu.removeClass("open");
  });

  /* Triggering the burger menu upon click */
  $("#burger").on('click', function () {
    open = !open;
    menu_toggle(open);
  });

  $('.shadow-card').on('click', function(e) {
    // Ignore clicks on actual links or buttons inside
    if (!$(e.target).closest('a, button').length) {
      var $button = $(this).find('a').first(); // Find the first <a> inside the card
      var url = $button.attr('href');
      var target = $button.attr('target') || '_self'; // Default to _self if no target

      if (url) {
        window.open(url, target);
      }
    }
  });

  // Event from toggle
  $('.event-list .event-button').on('click', function() {
    var eventTitle = $(this).data('title');
    
    if($('.contact-form').length > 0) {
      const sectionId = $('.contact-form').attr('id');
      
      $('.contact-form .event-title input').val(eventTitle).change();

      $('html, body').animate({
        scrollTop: $('#' + sectionId).offset().top
      }, 600);
    }
  });

  // Video toggle
  $('.video-toggle').on('click', function(){
    const video = $(this).siblings('video').get(0);

    if (video.paused) {
      video.setAttribute('controls', 'controls');
      video.play();
      $(this).addClass('active');
      $(this).find('i').removeClass('fa-play').addClass('fa-pause');
    } else {
      video.removeAttribute('controls');
      video.pause();
      $(this).removeClass('active');
      $(this).find('i').addClass('fa-play').removeClass('fa-pause');
    }
  });

  // blog iframes
  $('.blog-content p').each(function () {
    if ($(this).find('iframe').length) {
      $(this).addClass('iframe-wrapper');
    }
  });
});

/**
 * @name check_scroll
 * @description checks the scroll value of the window and adds a class to the header if the window is scrolled
**/
let check_scroll = () => {
  let scroll = $(window).scrollTop();
  if (scroll > 0) {
    $("header").addClass("scroll");
  } else {
    $("header").removeClass("scroll");
  }
};

/**
 * @name container_fix
 * @description function for fixing floating elements or page width elements with content to the conventional Bootstrap container sizes
**/
let container_fix = () => {
  if ($('.container-fix').length) {
    let containerWidths = {
      576: 540,
      768: 720,
      992: 960,
      1200: 1140,
      1440: 1440,
    };
    let windowWidth = $(window).width();
    let containerWidth = 0;
    for (const [key, value] of Object.entries(containerWidths)) {
      if (windowWidth >= key) {
        containerWidth = value;
      }
    }

    var padding = ((windowWidth - containerWidth) / 2) + 32;
    if (windowWidth >= 992) {
      $('.container-fix').each(function () {
        if ($(this).hasClass('odd')) {
          $(this).css('padding-left', '0px');
          $(this).css('padding-right', padding + 'px');
        } else if ($(this).hasClass('even')) {
          $(this).css('padding-left', padding + 'px');
          $(this).css('padding-right', '0px');
        }
      });
    } else if (windowWidth >= 576 && windowWidth <= 991) {
      $('.container-fix').each(function () {
        $(this).css('padding-left', padding + 'px');
        $(this).css('padding-right', padding + 'px');
      });
    } else {
      $('.container-fix').each(function () {
        $(this).css('padding-left', '32px');
        $(this).css('padding-right', '32px');
      });
    }
  }
};

/**
 * @name magnific_init
 * @description initialise the Magnific Popups for the page
**/
let magnific_init = () => {
  if($('.magnific').length > 0){
    $('.magnific').magnificPopup({
      type:'image',
      gallery: {
        enabled: true,
      }
    });
  }
};

/**
 * @name mega_menu
 * @description handles the offset for mega menus
**/
let mega_menu = () => {
  if ($('.mega-menu').length) {
    setTimeout(function() {
      let header_height = $('#header').outerHeight();
      $('.mega-menu').css('top', header_height + 'px');
    }, 500);
  }
}

/**
 * @name menu_toggle
 * @description handles opening and closing of the mobile menu on the site
 * @param {*} open flag indicating whether or not the menu is in an open state
**/
var open = false;
let menu_toggle = (open) => {
  $("#burger").toggleClass("open", open);
  $("#navigation-mobile > .menu-inner").toggleClass("open", open);
  $("#navigation > .menu-inner").toggleClass("open", open);
};

/**
 * @name slick_init
 * @description initialise the Slick sliders for the page (docs: https://kenwheeler.github.io/slick/)
**/
let slick_init = () => {
  $(".testimonials-slider").slick({
    dots: true,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    // adaptiveHeight: true,
    adaptiveHeight: false,
  });

  $(".case-studies-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 525,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: "unslick",
      },
    ],
  });

  $(".benefits-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".benefits-alt-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          slidesToShow: 4,
        }
      },
    ],
  });

  $(".logos-slider").slick({
    dots: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    autoplay: true,
    autoplaySpeed: 0,
    pauseOnHover: false,
    pauseOnFocus: false,
    pauseOnDotsHover: false,
    cssEase: 'linear',
    speed: 2500,
    responsive: [
      {
        breakpoint: 526,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".services-slider").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        }
      },
    ],
  });

  $(".products-solutions-slider-content").slick({
    dots: false,
    arrows: true,
    nextArrow: '<button class="slick-arrow slick-next"><i class="fa-solid fa-chevron-right"></i></button>',
    prevArrow: '<button class="slick-arrow slick-prev"><i class="fa-solid fa-chevron-left"></i></button>',
    slidesToScroll: 1,
    slidesToShow: 1,
    infinite: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 769,
        settings: {
          dots: true,
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 1201,
        settings: {
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 3,
        }
      },
    ],
  });
};

/**
 * @name universal_path_change
 * @description update paths appropriately during development
 */
let universal_path_change = (liveDomain, localDomain) => {
  const live = liveDomain;
  const local = localDomain;

  // Replace domain in <img> src attributes
  $('img').each(function () {
    const currentSrc = $(this).attr('src');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + '.mystagingwebsite.com'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + '.mystagingwebsite.com'));
    }
  });

  // Replace domain in <video> src attributes
  $('video').each(function () {
    const currentSrc = $(this).attr('src');
    const currentPoster = $(this).attr('poster');

    // Update test domain
    if (currentSrc && currentSrc.includes(local + '.test')) {
      $(this).attr('src', currentSrc.replace(local + '.test', live + '.mystagingwebsite.com'));
    }

    if (currentPoster && currentPoster.includes(local + '.test')) {
      $(this).attr('poster', currentPoster.replace(local + '.test', live + '.mystagingwebsite.com'));
    }

    // Update local domain
    if (currentSrc && currentSrc.includes('localhost:3000')) {
      $(this).attr('src', currentSrc.replace('localhost:3000', live + '.mystagingwebsite.com'));
    }

    if (currentPoster && currentPoster.includes('localhost:3000')) {
      $(this).attr('poster', currentPoster.replace('localhost:3000', live + '.mystagingwebsite.com'));
    }
  });

  // Replace domain in <div> background-image style attributes
  $('div').each(function () {
    const currentBg = $(this).css('background-image');

    // Update test domain
    if (currentBg && currentBg.includes(local + '.test')) {
      const updatedBg = currentBg.replace(local + '.test', live + '.mystagingwebsite.com');
      $(this).css('background-image', updatedBg);
    }

    // Update local domain
    if (currentBg && currentBg.includes('localhost:3000')) {
      const updatedBg = currentBg.replace('localhost:3000', live + '.mystagingwebsite.com');
      $(this).css('background-image', updatedBg);
    }
  });

  // Replace domain in <a> src attributes
  $('a').each(function () {
    const currentSrc = $(this).attr('href');

    // Update test domain
    if (currentSrc && currentSrc.includes(live + '.mystagingwebsite.com') && window.location.hostname === local + '.test') {
      $(this).attr('href', currentSrc.replace(live + '.mystagingwebsite.com', local + '.test'));
    }

    // Update test domain
    if (currentSrc && currentSrc.includes(live + '.mystagingwebsite.com') && window.location.hostname === 'localhost') {
      $(this).attr('href', currentSrc.replace(live + '.mystagingwebsite.com', 'localhost:3000'));
    }
  });
};

function noticeBanner(speed, selector) {
  $(selector).each(function () {
    const $track = $(this);
    const $originalSlides = $track.children();
    const originalCount = $originalSlides.length;

    // Clone slides in original order to reach at least 4
    if (originalCount < 4) {
      const slidesNeeded = 4 - originalCount;
      for (let i = 0; i < slidesNeeded; i++) {
        const indexToClone = i % originalCount;
        $track.append($originalSlides.eq(indexToClone).clone());
      }
    }

    // Duplicate all slides to enable infinite loop
    $track.append($track.children().clone());

    let position = 0;
    let lastTimestamp = null;

    function animate(timestamp) {
      if (!lastTimestamp) lastTimestamp = timestamp;
      const delta = timestamp - lastTimestamp;
      lastTimestamp = timestamp;

      position -= delta * speed;

      const $firstSlide = $track.children().first();
      const firstSlideWidth = $firstSlide.outerWidth(true);

      // Shift first slide to the end once fully out of view
      if (-position >= firstSlideWidth) {
        $firstSlide.appendTo($track);
        position += firstSlideWidth;
      }

      $track.css('transform', `translateX(${position}px)`);
      requestAnimationFrame(animate);
    }

    requestAnimationFrame(animate);
  });
} 